//css-------------------
import "@/css/home/schedule.scss";

//vue-datepicker-next
import(/* webpackPrefetch: true */ "vue-datepicker-next/index.css");



//components js-------------------
import(/* webpackPrefetch: true */ "@/js/share/components/_common_lazy");
import(/* webpackPrefetch: true */ "@/js/share/components/_font_family");
import { init_imageloaded } from "@/js/share/components/_imageloader.js";
import { sponsor_swiper } from "@/js/share/components/_sponsor_swiper.js";
import { sidenav_toggle } from "@/js/share/components/_sidenav.js";


//npm lib  
import $ from "jquery";
import { gsap } from "gsap";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";
import { createApp } from "vue";
import { baseData, baseWatch, baseMethods } from "@/js/share/_home_app";
import DatePicker from 'vue-datepicker-next';

const app = createApp({
    components: { DatePicker },
    data() {
        return {
            ...baseData(),
            data_mark: _data_mark,
            data_rating: _data_rating,
            schedule_row: [],
            schedule_item: [],
            detail_opened: {},
            timeline_slide: {},
            _wrapper_w: null,
            _slide_w: null,
            _max: 0,
            _dt: 0,
            format_timeline: false,
            select_cate: 108,
            datepicker_date: '2025-10-10',
            datepicker_lang: {
                formatLocale: {
                    firstDayOfWeek: 1,
                },
            },
            data_loading: false,
        };
    },
    watch: {
        select_cate() {
            const _this = this;
            if (this.select_cate == 109) {
                this.format_timeline = false;
            }
            // this.schedule_item = this.schedule_row[this.select_cate].find(i => i.date === _this.datepicker_date)
            //     ?? {
            //     date: _this.datepicker_date,
            //     cinemas: [],
            // };
            // this.timeline_slide_init();

            this.get_data();
        },
        datepicker_date() {
            const _this = this;
            // this.schedule_item = this.schedule_row[this.select_cate].find(i => i.date === _this.datepicker_date)
            //     ?? {
            //     date: _this.datepicker_date,
            //     cinemas: [],
            // };
            // this.timeline_slide_init();

            this.get_data();
        },
        ...baseWatch(this),
    },
    mounted() {
        const _this = this;
        this.fastlink_toggle();
        init_imageloaded(function () {
            sponsor_swiper();
            _this.get_data();
            // _this.timeline_slide_init();
        });
        // this.schedule_item = this.schedule_row[this.select_cate][0];
        // this.datepicker_date = this.schedule_item.date;
    },
    methods: {
        ...baseMethods,
        get_data() {
            const _this = this;
            $.ajax({
                data: {
                    select_cate: _this.select_cate,
                    datepicker_date: _this.datepicker_date,
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                type: 'POST',
                url: '/schedule/ajax',
                beforeSend: function () {
                    _this.data_loading = true;
                },
                success: function (response, status) {
                    _this.schedule_item = response[_this.select_cate][0];
                    _this.timeline_slide_init();
                },
                error: function (response, status) {

                },
            }).always(function (response, status) {
                console.log(response);
                _this.data_loading = false;
            });
        },
        timeline_slide_init() {
            if (!this.schedule_item) return;

            setTimeout(() => {
                const _this = this;
                this._wrapper_w = $('.slide_wrapper').width();
                this._slide_w = $('.slide').width();
                this._max = _this._slide_w - _this._wrapper_w;
                this._dt = _this._slide_w / 14 * 3;
                this.schedule_item.cinemas.forEach((cinema) => {
                    cinema.auditoriums.forEach((auditorium) => {
                        _this.timeline_slide[auditorium.id] = {
                            _i: 0,
                            _x: 0,
                            _slide: null,
                        };
                    });
                });
                if ($('.slide').length > 0) {
                    gsap.set('.slide', { x: 0 });
                };
            }, 100);
        },
        slide_prev(el, id) {
            const _this = this;
            this.timeline_slide[id]._slide = $(el.target).parent().find('.slide');
            this.timeline_slide[id]._i -= 1;
            this.timeline_slide[id]._x = this._dt * this.timeline_slide[id]._i;
            if (this.timeline_slide[id]._i <= 0) this.timeline_slide[id]._i = 0;
            if (this.timeline_slide[id]._x <= 0) this.timeline_slide[id]._x = 0;
            gsap.to(_this.timeline_slide[id]._slide, { duration: .6, x: -_this.timeline_slide[id]._x, ease: 'power2.out' });
        },
        slide_next(el, id) {
            const _this = this;
            this.timeline_slide[id]._slide = $(el.target).parent().find('.slide');
            this.timeline_slide[id]._i += 1;
            this.timeline_slide[id]._x = this._dt * this.timeline_slide[id]._i;
            if (this.timeline_slide[id]._i >= 3) this.timeline_slide[id]._i = 3;
            if (this.timeline_slide[id]._x >= this._max) this.timeline_slide[id]._x = this._max;
            gsap.to(_this.timeline_slide[id]._slide, { duration: .6, x: -_this.timeline_slide[id]._x, ease: 'power2.out' });
        },
        sidenav_toggle,
        detail_open_handler(item, id, cinema_index, auditorium_index) {
            this.schedule_item.cinemas[cinema_index].auditoriums[auditorium_index]._detail = item;
            this.detail_opened[id] = true;
        },
        onEnter(el) {
            el.style.willChange = 'height, opacity';
            el.style.overflow = 'hidden';
            el.style.height = '0px';
            el.style.opacity = '0';
            // 下一幀再切到實際高度，觸發 transition
            requestAnimationFrame(() => {
                const h = el.scrollHeight; // 內容實際高度
                el.style.transition = 'height 240ms ease, opacity 240ms ease';
                el.style.height = h + 'px';
                el.style.opacity = '1';
            });
        },
        onAfterEnter(el) {
            el.style.transition = '';
            el.style.height = 'auto';   // 動畫後還原成 auto，之後內容變動不會被限制
            el.style.overflow = '';
            el.style.willChange = '';
        },
        onLeave(el) {
            el.style.willChange = 'height, opacity';
            el.style.overflow = 'hidden';
            // 先設成目前實高，再收回 0 觸發收合動畫
            el.style.height = el.scrollHeight + 'px';
            el.style.opacity = '1';
            // 強制一次 reflow，確保起點生效
            void el.offsetHeight;
            el.style.transition = 'height 180ms cubic-bezier(0.2, 0, 0.2, 1), opacity 180ms linear';
            el.style.height = '0px';
            el.style.opacity = '0';
        },
        onAfterLeave(el) {
            el.style.transition = '';
            el.style.overflow = '';
            el.style.willChange = '';
        },
    },
})

app.mount("#app");
